/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coding DNA / RNA sequence`)
};

const es_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secuencia codificante de ADN / ARN`)
};

const de_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodierende DNA-/RNA-Sequenz`)
};

const nl_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coderende DNA-/RNA-sequentie`)
};

const fr_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séquence codante ADN / ARN`)
};

const it_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequenza codificante DNA / RNA`)
};

const pt_br2_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência codificante de DNA / RNA`)
};

const pt_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência codificante de ADN / ARN`)
};

const ja_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードDNA / RNA配列`)
};

const zh_rscu_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编码 DNA / RNA 序列`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_input_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_input_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_input_label", locale)
	if (locale === "en") return en_rscu_input_label(inputs)
	if (locale === "es") return es_rscu_input_label(inputs)
	if (locale === "de") return de_rscu_input_label(inputs)
	if (locale === "nl") return nl_rscu_input_label(inputs)
	if (locale === "fr") return fr_rscu_input_label(inputs)
	if (locale === "it") return it_rscu_input_label(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_input_label(inputs)
	if (locale === "pt") return pt_rscu_input_label(inputs)
	if (locale === "ja") return ja_rscu_input_label(inputs)
	return zh_rscu_input_label(inputs)
};